export enum RAGMode {
  ChunkOnly = 'chunk_only',
  Adjacent = 'adjacent',
  AdjacentTwo = 'adjacent_two',
}
